module.exports = __webpack_public_path__ + "static/media/iconsearch.907080be.svg";